import * as React from 'react';
import { connect } from 'react-redux';
import { AppState } from '../../store';
import { bindActionCreators, Dispatch } from 'redux';

import * as GroupStore from '../../store/Group';

import { Button, Col, Row, Spinner, Tooltip } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { Group } from '../../types/Group/Group';
import { history } from '../../store/configureStore';
import { User } from 'oidc-client';

type GroupTableProps = {
    dispatch: Dispatch;
    groupState: GroupStore.GroupState;
    user: User;
    actions:  typeof GroupStore.actionCreators;// & typeof GroupStore.actionCreators;
}

interface GroupTableState {
    showMatchTenantModal: boolean;
    showUnlinkTenantModal: boolean;
    group: Group | undefined;
}

class GroupsTable extends React.Component<GroupTableProps, GroupTableState> {
    public constructor(props: GroupTableProps) {
        super(props);
        this.state = {
            showMatchTenantModal: false,
            showUnlinkTenantModal: false,
            group: undefined,
        };
    }

    public componentDidMount() {
        this.ensureDataFetched();
    }

    public componentDidUpdate() {
        this.ensureDataFetched();
    }

    private ensureDataFetched() {
        this.props.actions.requestGroups();
    }


    render() {
        const NoDataComponent: React.FunctionComponent = (): React.ReactElement => {
            if(this.props.groupState.isLoadedData){
                return (
                    <div className="d-flex justify-content-center mt-3" data-cy="bootstrap-table-loaded">
                        <p className="text-center">No groups were found.</p>
                    </div>
                );
            }
            else{
                return (
                    <div className="d-flex justify-content-center mt-3">
                        <Spinner animation="border" variant="primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>
                );
            }
        };

        const { SearchBar } = Search;

        const columns = [
            {
                dataField: 'name',
                text: 'Name',
                sort: true,
            },
            {
                dataField: 'id',
                text: 'Group ID',
                sort: true,
            },
            {
                dataField: 'reportCount',
                text: 'Report Count',
                sort: true,
            },
            {
                dataField: 'dashboardCount',
                text: 'Dashboard Count',
                sort: true,
            },
            {
                dataField: 'tenantDomain',
                text: 'Tenant',
                sort: true,
            }
            /*{
                dataField: 'id',
                text: '',
                sort: false,
                formatter: (cell: any, row: Group) => { 
                    if(row.id !== undefined && row.id !== null){
                        var id = row.id;
                        return (
                            <Button 
                                variant="link" 
                                className='text-start'
                                onClick={() => history.push(`/groups/${id}`)}>
                                    {row.groupName}
                            </Button>
                        );
                    }
                }

            },*/
        ];

        const rowEvents: Partial<any> = {
            /*onClick: (e: React.MouseEvent<HTMLButtonElement>, row: Group, rowIndex: number) => {
                e.preventDefault();
                e.stopPropagation();
                let target = e.target as HTMLButtonElement;
                // Only goto tenant details when it's not a link click
                if(!target.classList.contains('btn-link')){
                    history.push(`/groups/${row.id}`);
                }
            },*/
        };

        return (
            <React.Fragment>
                <ToolkitProvider
                    keyField="id"
                    search
                    data={ this.props.groupState.data } 
                    columns={ columns } 
                    >
                    {
                        props => (
                        <React.Fragment>
                            <Row>
                                <Col>
                                    <SearchBar { ...props.searchProps } />
                                </Col>
                            </Row>
                            <BootstrapTable
                                { ...props.baseProps }
                                id="groupTable"
                                classes='clickable'
                                striped
                                hover
                                bordered={false}
                                defaultSorted={ [{ dataField: 'name', order: 'asc' }] }
                                pagination={ paginationFactory({sizePerPage: 25}) }
                                noDataIndication={ () => <NoDataComponent /> }
                                rowEvents={ rowEvents }
                            />
                        </React.Fragment>
                        )
                    }
                </ToolkitProvider>

            </React.Fragment>
        );
    }
}

function mapStateToProps(state: AppState) {
    return {
        groupState: state.group,
        user: state.oidc.user,
    };
}

export default connect(
    mapStateToProps,
    (dispatch) => {
        return {
            dispatch: dispatch,
            actions: bindActionCreators(Object.assign(
                {}, 
                GroupStore.actionCreators,
            ), dispatch )
        }
    }
)(GroupsTable as any);